// Sentry instrumentation must be imported before any other modules
import '@/lib/sentry'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/_app/App'
import { initKeycloak } from '@/lib/keycloak'
import '@/_app/styles/globals.css'

const rootElement = document.getElementById('root')

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement)

  // Initialize Keycloak before rendering the app
  initKeycloak(() => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    )
  })
}
